import React from "react"
import {MapNN} from "./Map";

export const RegionMap = ({...props}) =>
{
    return <MapNN {...props}></MapNN>
}